import Component from "@glimmer/component";
import { trustHTML } from "@ember/template";
import DDecoratedHtml from "discourse/ui-kit/d-decorated-html";
import { i18n } from "discourse-i18n";
import { isCollapsible } from "discourse/plugins/chat/discourse/components/chat-message-collapser";
import ChatMessageCollapser from "./chat-message-collapser.gjs";

export default class ChatMessageText extends Component {
  get isEdited() {
    return this.args.edited ?? false;
  }

  get isCollapsible() {
    return isCollapsible(this.args.cooked, this.args.uploads);
  }

  <template>
    <div class="chat-message-text">
      {{#if this.isCollapsible}}
        <ChatMessageCollapser
          @cooked={{@cooked}}
          @decorate={{@decorate}}
          @onToggleCollapse={{@onToggleCollapse}}
          @uploads={{@uploads}}
        />
      {{else}}
        <DDecoratedHtml
          @className="chat-cooked"
          @decorate={{@decorate}}
          @html={{trustHTML @cooked}}
        />
      {{/if}}

      {{#if this.isEdited}}
        <span class="chat-message-edited">({{i18n "chat.edited"}})</span>
      {{/if}}

      {{yield}}
    </div>
  </template>
}
